export enum PermissionStoreModelEnum {
  ViewAlertSopLink = 'VIEW_ALERT_SOP_LINK',
  ViewAnySites = 'VIEW_ANY_SITES',
  ViewOwnSites = 'VIEW_OWN_SITES',
  ManageAnyChargerBasicCommands = 'MANAGE_ANY_CHARGER_BASIC_COMMANDS',
  ManageAnyChargerPowerCommand = 'MANAGE_ANY_CHARGER_POWER_COMMAND',
  ManageAnyChargerResetCommand = 'MANAGE_ANY_CHARGER_RESET_COMMAND',
  ManageAnyChargerMassResetCommand = 'MANAGE_ANY_CHARGER_MASS_RESET_COMMAND',
  ManageAnyChargerMassCustomCommand = 'MANAGE_ANY_CHARGER_MASS_CUSTOM_COMMAND',
  ManageAnyChargerReconnect = 'MANAGE_ANY_CHARGER_RECONNECT',
  ManageAnyChargerCustomCommand = 'MANAGE_ANY_CHARGER_CUSTOM_COMMAND',
  ManageAnyChargingSessionPriority = 'MANAGE_ANY_CHARGING_SESSION_PRIORITY',
  ManageOwnChargerBasicCommands = 'MANAGE_OWN_CHARGER_BASIC_COMMANDS',
  ManageOwnChargerPowerCommand = 'MANAGE_OWN_CHARGER_POWER_COMMAND',
  ManageOwnChargerResetCommand = 'MANAGE_OWN_CHARGER_RESET_COMMAND',
  ManageOwnChargerMassResetCommand = 'MANAGE_OWN_CHARGER_MASS_RESET_COMMAND',
  ManageOwnChargerMassCustomCommand = 'MANAGE_OWN_CHARGER_MASS_CUSTOM_COMMAND',
  ManageOwnChargerReconnect = 'MANAGE_OWN_CHARGER_RECONNECT',
  ManageOwnChargerCustomCommand = 'MANAGE_OWN_CHARGER_CUSTOM_COMMAND',
  ManageOwnChargingSessionPriority = 'MANAGE_OWN_CHARGING_SESSION_PRIORITY',
  ManageAnyIdTag = 'MANAGE_ANY_ID_TAG',
  ManageOwnIdTag = 'MANAGE_OWN_ID_TAG',
  ManageAnySchedule = 'MANAGE_ANY_SCHEDULE',
  ManageOwnSchedule = 'MANAGE_OWN_SCHEDULE',
  ViewWorkflow = 'VIEW_WORKFLOW',
  RestartWorkflowStep = 'RESTART_WORKFLOW_STEP',
  ResolveWorkflowStep = 'RESOLVE_WORKFLOW_STEP',
  ManageWorkflowAdminActions = 'MANAGE_WORKFLOW_ADMIN_ACTIONS',
  StartNewWorkflow = 'START_NEW_WORKFLOW',
  ManageAnyLoadProfileTrigger = 'MANAGE_ANY_LOAD_PROFILE_TRIGGER',
  ManageOwnLoadProfileTrigger = 'MANAGE_OWN_LOAD_PROFILE_TRIGGER',
  ManageAnyAlert = 'MANAGE_ANY_ALERT',
  ManageOwnAlert = 'MANAGE_OWN_ALERT',
  ViewAnyDashboard = 'VIEW_ANY_DASHBOARD',
  ViewOwnDashboard = 'VIEW_OWN_DASHBOARD',
  ManageAnyBessCommands = 'MANAGE_ANY_BESS_COMMANDS',
  ManageOwnBessCommands = 'MANAGE_OWN_BESS_COMMANDS',
  ManageAnyChargerConfiguration = 'MANAGE_ANY_CHARGER_CONFIGURATION',
  ManageOwnChargerConfiguration = 'MANAGE_OWN_CHARGER_CONFIGURATION',
  ManageAnyChargerDiagnostics = 'MANAGE_ANY_CHARGER_DIAGNOSTICS',
  ManageOwnChargerDiagnostics = 'MANAGE_OWN_CHARGER_DIAGNOSTICS',
  ViewAnyAnalytics = 'VIEW_ANY_ANALYTICS',
  ViewOwnAnalytics = 'VIEW_OWN_ANALYTICS',
  ViewAnyChargerUptime = 'VIEW_ANY_CHARGER_UPTIME',
  ViewOwnChargerUptime = 'VIEW_OWN_CHARGER_UPTIME',
  ViewAnyChargerLiveIssues = 'VIEW_ANY_CHARGER_LIVE_ISSUES',
  ViewOwnChargerLiveIssues = 'VIEW_OWN_CHARGER_LIVE_ISSUES',
  ViewAnyFinanceAnalytics = 'VIEW_ANY_FINANCE_ANALYTICS',
  ViewOwnFinanceAnalytics = 'VIEW_OWN_FINANCE_ANALYTICS',
  ViewAnyEnergyTradingDashboard = 'VIEW_ANY_ENERGY_TRADING_DASHBOARD',
  ViewOwnEnergyTradingDashboard = 'VIEW_OWN_ENERGY_TRADING_DASHBOARD',
  ViewAnyGbTradingPositionCalculation = 'VIEW_ANY_GB_TRADING_POSITION_CALCULATION',
  ManageAnyGbTradingPositionCalculation = 'MANAGE_ANY_GB_TRADING_POSITION_CALCULATION',
  RecalculateDispatchLoadProfile = 'RECALCULATE_DISPATCH_LOAD_PROFILE',
  ViewAnyIdTag = 'VIEW_ANY_ID_TAG',
  ViewOwnIdTag = 'VIEW_OWN_ID_TAG',
  ViewAnyVehicles = 'VIEW_ANY_VEHICLES',
  ViewOwnVehicles = 'VIEW_OWN_VEHICLES',
  ViewDataflow = 'VIEW_DATAFLOW',
  ViewAnyAuditLogs = 'VIEW_ANY_AUDIT_LOGS',
  ViewOwnAuditLogs = 'VIEW_OWN_AUDIT_LOGS',
  ViewAnyKiosk = 'VIEW_ANY_KIOSK',
  ViewOwnKiosk = 'VIEW_OWN_KIOSK',
  ViewAnyReports = 'VIEW_ANY_REPORTS',
  ViewOwnReports = 'VIEW_OWN_REPORTS',
  ViewAnyChargerConfiguration = 'VIEW_ANY_CHARGER_CONFIGURATION',
  ViewOwnChargerConfiguration = 'VIEW_OWN_CHARGER_CONFIGURATION',
  ViewAnySiteWithAiAssistant = 'VIEW_ANY_SITE_WITH_AI_ASSISTANT',
  ViewOwnSiteWithAiAssistant = 'VIEW_OWN_SITE_WITH_AI_ASSISTANT',
  ViewAnyUsers = 'VIEW_ANY_USERS',
  ViewOwnUsers = 'VIEW_OWN_USERS',
  ManageAnyUsers = 'MANAGE_ANY_USERS',
  ManageOwnUsers = 'MANAGE_OWN_USERS',
  ImpersonateAnyUser = 'IMPERSONATE_ANY_USER',
  ManageAnyGridTargetOverride = 'MANAGE_ANY_GRID_TARGET_OVERRIDE',
  ManageOwnGridTargetOverride = 'MANAGE_OWN_GRID_TARGET_OVERRIDE',
  ViewAnyPowerManagementDetails = 'VIEW_ANY_POWER_MANAGEMENT_DETAILS',
  ViewOwnPowerManagementDetails = 'VIEW_OWN_POWER_MANAGEMENT_DETAILS',
  ViewAnyPredictiveInfraOverview = 'VIEW_ANY_PREDICTIVE_INFRA_OVERVIEW',
  ViewOwnPredictiveInfraOverview = 'VIEW_OWN_PREDICTIVE_INFRA_OVERVIEW',
  ViewAnyPredictiveInfraChargerPerformance = 'VIEW_ANY_PREDICTIVE_INFRA_CHARGER_PERFORMANCE',
  ViewOwnPredictiveInfraChargerPerformance = 'VIEW_OWN_PREDICTIVE_INFRA_CHARGER_PERFORMANCE',
  ViewAnyPredictiveInfraVehicleHealth = 'VIEW_ANY_PREDICTIVE_INFRA_VEHICLE_HEALTH',
  ViewOwnPredictiveInfraVehicleHealth = 'VIEW_OWN_PREDICTIVE_INFRA_VEHICLE_HEALTH',
}
